import React from 'react';

/**
 * Manual-dial confirmation once a contact has hit the 3-calls-per-24h cap.
 * @param {{onCancel: () => void, onConfirm: () => void}} props
 * @returns {JSX.Element}
 */
export default function CallFrequencyDialog({ onCancel, onConfirm }) {
  return (
    <div className="fixed inset-0 z-[1000] bg-black/70 flex items-center justify-center p-4" role="alertdialog" aria-modal="true" aria-label="Daily call limit" onClick={(e) => e.stopPropagation()}>
      <div className="panel max-w-md w-full p-5 space-y-4 border border-rose-500/50">
        <p className="text-sm text-white/90 leading-relaxed">
          This contact has already been called 3 times today. Additional dials may violate state harassment rules.
          Do you still wish to proceed?
        </p>
        <div className="flex justify-end gap-2">
          <button type="button" autoFocus onClick={onCancel} className="px-4 py-2 rounded-md bg-civix-purple text-white text-sm font-semibold hover:bg-violet-500">Cancel</button>
          <button type="button" onClick={onConfirm} className="px-4 py-2 rounded-md border border-rose-500/50 text-rose-200 text-sm hover:bg-rose-500/10">Proceed anyway</button>
        </div>
      </div>
    </div>
  );
}
